import * as types from './ActionTypes';
import firebaseConfig from './firebaseConfig';

export default {
  firebaseConfig: firebaseConfig,
  c: types
}